import React from "react";
import "./Profile.css";
import {
  Card,
  Spacer,
} from "../../Layout/Layout";

import ProfileBrief from "../../UI/Profile/Brief";

import { Type, TextBold, TextSize } from "../../Type/Type";

const Profile = ({ location }) => {

  // console.log("location:" + JSON.stringify(location,null,2))
  const listLeft = [];
  const listRight = [];

  listLeft.push({ name: "Reference number", value: location.refNumber });
  listLeft.push({ name: "Address", value: location.address });
  listLeft.push({ name: "Postal Code", value: location.postalCode });

  listRight.push({ name: "Organization", value: location.organization.name });
  listRight.push({ name: "Place", value: location.place });

  return (
    <Spacer>
      <Card>
        <Spacer>
          <Spacer>
          <Type size={TextSize.lg} boldness={TextBold.bold}>
            {location.name}
          </Type>
          </Spacer>          
          <ProfileBrief listLeft={listLeft} listRight={listRight} />
        </Spacer>
      </Card>
    </Spacer>
  );
};

export default Profile;
